export default "__VITE_ASSET__ada3fcfb__"